import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { QrcodeService } from '../services/qrcode.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-qrcode-result',
  templateUrl: './qrcode-result.component.html',
  styleUrls: ['./qrcode-result.component.css'],
  standalone: false,
})
export class QrcodeResultComponent implements OnInit {

  qrdata: any[] = [];

  // NOTE: 配列の内容は、QRコードのサイズ、プルダウン選択肢、タイトル等のフォントサイズ
  qrSizes: any = [
    [260, this.translate.instant('A4サイズ 1ページに 6個'), 14],
    [400, this.translate.instant('A4サイズ 1ページに 2個'), 18],
    [640, this.translate.instant('A4サイズ 1ページに 1個'), 28],
  ];
  qrSize: number = this.qrSizes[0][0];
  fontSize: number = this.qrSizes[0][2];

  qrFormGroup!: FormGroup;
  settingQrSizeControl!: FormControl;
  settingFontSizeControl!: FormControl;

  currentLang: string = 'ja';

  constructor(
    private qrcodeService: QrcodeService,
    private formBuilder: FormBuilder,
    private translate: TranslateService
  ) { }

  ngOnInit(): void {
    this.qrdata = this.qrcodeService.qrdata;
    this.createForm();
    this.currentLang = this.translate.currentLang;
  }

  private createForm() {
    this.qrFormGroup = this.formBuilder.group(
      {
        settingQrSize: [this.qrSize],
        settingFontSize: [this.fontSize],
      }
    );
    this.settingQrSizeControl = this.qrFormGroup.get('settingQrSize') as FormControl;
    this.settingFontSizeControl = this.qrFormGroup.get('settingFontSize') as FormControl;
  }

  printClick(): void {
    try {
      if(!document.execCommand('print', false, undefined)) {
        window.print()
      }
    } catch {
      window.print()
    }
  }

  changePreset(event: any): void {
    this.qrSize = event.value;
    const selectSize = this.qrSizes.filter((e: any) => e[0] == event.value)[0];
    this.fontSize = selectSize[2];
    this.settingQrSizeControl.setValue(this.qrSize);
    this.settingFontSizeControl.setValue(this.fontSize);
  }

  changeSize(): void {
    this.qrSize = this.settingQrSizeControl.value;
    this.fontSize = this.settingFontSizeControl.value;
  }

}
